import { reactive, toRefs, onMounted, watch, computed } from 'vue'
import store from '@/store'
// import { i18n } from '@/i18n'
import route from '@/router'
import debounce from 'lodash/debounce'
import moment from 'moment'
import { getPromo } from '@/api/channels/distributor'

export default () => {
  const routeName = route.app._route.name
  const state_ = reactive({
    t_head: [
      'checkbox',
      'voucher_type',
      'voucher_name',
      'periode',
      'kuota',
      'status',
      'action',
    ],
    voucher_list: [],
    sorting_optional: [
      {
        label: 'Terbaru',
        value: 'DESC',
      },
      {
        label: 'Terlama',
        value: 'ASC',
      },
    ],
    pagination: {
      size: 20,
      total_items: 0,
    },
    searchParam: route.app._route.query.query || '',
    dates: route.app._route.query.query?.start_date
      ? [route.app._route.query.query.start_date, route.app._route.query.query.end_date]
      : [],
  })

  const page = computed(() => {
    return +route.app._route.query.page || 1
  })

  const permission = computed(() => store.getters['user/can']('voucher', 'reverse'))

  const fetchVoucher = debounce(async () => {
    const is_principle = store.state.user.restriction_base === 'Business'
    await getPromo({
      channel_id: route.app._route.params.id,
      params: {
        type: 'VOUCHER',
        limit: state_.pagination.size,
        page: page.value,
        business_id: route.app._route.query.business_id,
        search: route.app._route.query.search || undefined,
        is_principle,
        sort: route.app._route.query.sort || 'createdAt',
        order: route.app._route.query.order || 'DESC',
        status: route.app._route.query.status || 'ALL',
        start_date: route.app._route.query.start_date || '',
        end_date: route.app._route.query.end_date || '',
      },
    })
    .then(({ data }) => {
      state_.voucher_list = data?.data || []
      state_.pagination.total_items = data?.total_row || 0
    })
    .catch(() => {
      state_.voucher_list = []
      state_.pagination.total_items = 0
    })
  }, 500)

  const changePage = (value) => {
    route.push({
      query: {
        ...route.app._route.query,
        page: value,
        search: undefined,
        sort: undefined,
      },
    })
  }

  const handleSearch =  debounce((e) => {
    const q = e.target.value
    state_.searchParam = q
    route.push({
      query: {
        ...route.app._route.query,
        search: state_.searchParam || undefined,
        page: undefined,
      },
    })
  }, 500)

  const handleSelect = (e) => {
    route.push({
      query: {
        ...route.app._route.query,
        order: e,
      },
    })
  }

  const handleStatus = (e) => {
    route.push({
      query: {
        ...route.app._route.query,
        status: e,
        page: undefined,
      },
    })
  }

  const handleDate = (date) => {
    route.push({
      query: {
        ...route.app._route.query,
        start_date: date[0] ? moment(date[0]).startOf('day').format() : '',
        end_date: date[1] ? moment(date[1]).endOf('day').format() : '',
        page: undefined,
      },
    })
  }

  const toEditVoucher = (id, type = '') => {
    const query = {
      ...route.app._route.query,
      voucher_id: id,
      is_detail: type ? true : undefined,
    }

    route.push({
      name: 'promotion-channel.voucher.add',
      query,
    })
  }

  watch(
    () => route.app._route.query, () => {
      if (route.app._route.name == routeName) {
        fetchVoucher()
      }
    },
  )

  watch(
    () => permission.value, () => {
      fetchVoucher()
    },
  )

  onMounted(() => {
    fetchVoucher()
    // console.log('_ : ', _);
  })

  return {
    ...toRefs(state_),
    changePage,
    handleStatus,
    handleSelect,
    handleDate,
    page,
    handleSearch,
    toEditVoucher,
    permission,
  }
}